'use client';

import { useQueryErrorResetBoundary } from '@tanstack/react-query';

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  const { reset: resetQueries } = useQueryErrorResetBoundary();

  return (
    <div className="flex min-h-[50vh] flex-col items-center justify-center gap-4 text-center">
      <h2 className="text-2xl font-semibold">Något gick fel</h2>
      <p className="text-muted-foreground">
        Ett oväntat fel uppstod. Försök igen.
      </p>
      <button
        onClick={() => {
          resetQueries();
          reset();
        }}
        className="bg-primary text-primary-foreground hover:bg-primary/90 rounded-md px-4 py-2 text-sm font-medium"
      >
        Försök igen
      </button>
    </div>
  );
}
